import RateEvaluationView from "../../features/performance/RateEvaluationView";

const RateEvaluationPage = () => <RateEvaluationView />;

export default RateEvaluationPage;
